import React, { useEffect, useState } from "react";
import DocumentMeta from "react-document-meta";
import Nav from "../Common/Nav";
import Footer from "../Common/Footer";
import { ProductName } from "../Common/ProductName";
import { baseUrl } from "../Common/BaseUrl";
import axios from "axios";

const TradingMore = () => {
  const meta = {
    title: `Trading Idea | ${ProductName} Exchange`,
    description: `Login on ${ProductName} Exchange now and start trading! Invite your friends to ${ProductName} Exchange.`,
    meta: {
      charset: "utf-8",
      name: {
        keywords: `${ProductName} Exchange, Crypto Exchange, Buy Sell Crypto, Bitcoin Exchange India`,
      },
    },
  };

  const [record, setRecord] = useState([]);
  const [recordStatus, setRecordStatus] = useState(false);

  useEffect(() => {
    const getData = async () => {
      try {
        const res = await axios.get(`${baseUrl}/tradeideas/get`);
        setRecordStatus(res.data.status);
        setRecord(res.data.data);
      } catch (err) {
        console.error("Failed to fetch trading ideas from Redis:", err);
        setRecordStatus(false);
      }
    };

    getData();
  }, []);

  const showTableHtml = () => {
    if (!recordStatus) return <p>No trading ideas found.</p>;

    return record.map((value) => (
      <div className="col-md-4 col-sm-6 col-12 more-space" key={value.id}>
        <div className="market-outer">
          <div className="market-inner">
            <div className="img-outer">
              <a href={"/trading-idea/" + value.id}>
                <img
                  src={`${baseUrl}/static/${value.image}`}
                  alt={value.heading}
                  className="img-fluid"
                />
              </a>
            </div>
            <div className="content-outer">
              <h4>{value.heading}</h4>
              <h6>{value.subtitle}</h6>
              <p>{value.description}</p>
              <a href={"/trading-idea/" + value.id}>read more</a>
            </div>
          </div>
        </div>
      </div>
    ));
  };

  return (
    <DocumentMeta {...meta}>
      <Nav graphColor={""} />
      <div className="market-news-outer more-blog-main">
        <div className="container">
          <h2 className="text-center mb-4">Trading Ideas</h2>
          <div className="row">{showTableHtml()}</div>
        </div>
      </div>
      <Footer />
    </DocumentMeta>
  );
};

export default TradingMore;
